module.exports = __webpack_public_path__ + "img/superior_rating.5393c41b.webp";